import { JourneyInterface, QuestInterface, QuestType, QuestUserContextInterface, Slug } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK apps/server/src/API/Quests/Quests.Controller.ts
export class QuestsAPI {
  static async getAllQuestsAndJourneys(orgId: number, includeData = false) {
    return APIService.Server.get<{
      journeys: JourneyInterface[];
      quests: QuestInterface[];
    }>(`/quests/org/${orgId}`, { includeData });
  }
  static async getQuestBySlug(orgId: number, slug: Slug) {
    return APIService.Server.get<QuestInterface>(`/quests/org/${orgId}/slug/${slug}`);
  }
  static async getQuestOfType(orgId: number, type: QuestType) {
    return APIService.Server.get<QuestInterface>(`/quests/org/${orgId}/type/${type}`);
  }
  static async updateQuests(orgId: number, quests: Partial<QuestInterface>[]) {
    return APIService.Server.put<QuestInterface[]>(`/quests/org/${orgId}`, quests);
  }
  static async createQuest(orgId: number, quest: Partial<QuestInterface>) {
    return APIService.Server.post<QuestInterface>(`/quests/org/${orgId}`, quest);
  }
  static async deleteQuest(orgId: number, questId: number) {
    return APIService.Server.delete<boolean>(`/quests/org/${orgId}/quest/${questId}`);
  }
  static async getQuestContext(orgId: number, questContextId: number) {
    return APIService.Server.get<QuestUserContextInterface>(`/quests/org/${orgId}/context/${questContextId}`);
  }
}
